import { defineMessages } from 'react-intl';

export default defineMessages({
  seoTitle: {
    id: 'cc4.seo.negative-advice.title',
    defaultMessage: '',
  },
  seoDescription: {
    id: 'cc4.seo.negative-advice.description',
    defaultMessage: '',
  },
  negativeAdviceCompensationTitle: {
    id: 'cc4.form.negative-advice.compensation-title',
    defaultMessage:
      'Unfortunately you are not entitled to receive compensation for this flight',
  },
  negativeAdviceTicketRefundTitle: {
    id: 'cc4.form.negative-advice.ticket-refund-title',
    defaultMessage:
      'Unfortunately you are not entitled to receive a refund for this flight',
  },
  backButtonText: {
    id: 'cc4.form.negative-advice.button.back',
    defaultMessage: 'Back',
  },
  submitContinue: {
    id: 'cc4.form.negative-advice.button.submit-continue',
    defaultMessage: 'Check another flight',
  },
  asideText: {
    id: 'cc4.form.negative-advice.aside-text',
    defaultMessage:
      'Airlines are legally required to pay compensation for disrupted flights up to three years old',
  },
  flightNotEligible: {
    id: 'cc4.form.negative-advice.flight-not-eligible',
    defaultMessage: 'This flight is not eligible for compensation.',
  },
  otherOptions: {
    id: 'cc4.form.negative-advice.other-options',
    defaultMessage: 'Your other options',
  },
  firstBoxTitle: {
    id: 'cc4.form.negative-advice.protect-flight-title',
    defaultMessage: 'Protect your future flights',
  },
  firstBoxSubTitle: {
    id: 'cc4.form.negative-advice.protect-flight-subtitle',
    defaultMessage:
      'Become a member of Flight Delayed Premium and enjoy these special benefits:',
  },
  secondBoxTitle: {
    id: 'cc4.form.negative-advice.check-another-flight-title',
    defaultMessage: 'Check another flight',
  },
  secondBoxSubTitle: {
    id: 'cc4.form.negative-advice.check-another-flight-subtitle',
    defaultMessage:
      "This flight wasn't eligible for compensation but maybe your other flight is.",
  },
  premiumButtonText: {
    id: 'cc4.form.negative-advice.premium-button-text',
    defaultMessage: 'Get Premium for just €2.50/month',
  },
  protectClaimsBoxTitleOne: {
    id: 'cc4.form.negative-advice.protect-claims-box-title-one',
    defaultMessage: 'Access to 1.500+ airport lounges',
  },
  protectClaimsBoxTitleTwo: {
    id: 'cc4.form.negative-advice.protect-claims-box-title-two',
    defaultMessage: 'Zero commission',
  },
  protectClaimsBoxTitleThree: {
    id: 'cc4.form.negative-advice.protect-claims-box-title-three',
    defaultMessage: 'Priority support',
  },
  protectClaimsBoxSubTitleOne: {
    id: 'cc4.form.negative-advice.protect-claims-box-subtitle-one',
    defaultMessage: 'in the event of a disruption',
  },
  protectClaimsBoxSubTitleTwo: {
    id: 'cc4.form.negative-advice.protect-claims-box-subtitle-two',
    defaultMessage: 'on the next three successful EU261 compensation claims',
  },
  protectClaimsBoxSubTitleThree: {
    id: 'cc4.form.negative-advice.protect-claims-box-subtitle-three',
    defaultMessage: 'from our customer service team',
  },
  checkNextClaimsBoxTitleOne: {
    id: 'cc4.form.negative-advice.check-next-claims-box-title-one',
    defaultMessage: 'All airlines supported',
  },
  checkNextClaimsBoxTitleTwo: {
    id: 'cc4.form.negative-advice.check-next-claims-box-title-two',
    defaultMessage: 'Claim compensation for old flights',
  },
  checkNextClaimsBoxTitleThree: {
    id: 'cc4.form.negative-advice.check-next-claims-box-title-three',
    defaultMessage: 'Success rate of 98% of court cases',
  },
  checkNextClaimsBoxSubTitleOne: {
    id: 'cc4.form.negative-advice.check-next-claims-box-subtitle-one',
    defaultMessage: 'from low-cost to national carriers',
  },
  checkNextClaimsBoxSubTitleTwo: {
    id: 'cc4.form.negative-advice.check-next-claims-box-subtitle-two',
    defaultMessage: 'from even 6 years ago',
  },
  checkNextClaimsBoxSubTitleThree: {
    id: 'cc4.form.negative-advice.check-next-claims-box-subtitle-three',
    defaultMessage: 'across Europe',
  },
});
